//@ts-nocheck
import React, { ReactElement } from 'react';
import ReactPlayer from 'react-player';
import styled from 'styled-components';

import { VideoPlayerProps } from 'features/player/types';

const VideoPlayer = styled(ReactPlayer)<{
  customWidth: ResponsiveSizes;
  customHeight: ResponsiveSizes;
  customMaxWidth: ResponsiveSizes;
  customMaxHeight: ResponsiveSizes;
}>`
  display: flex;
  flex-grow: 1;
  background: black;
  align-items: center;
  justify-content: center;

  ${({ customWidth, theme: { mediaQueries } }) => {
    if (typeof customWidth === 'object') {
      let response = '';

      if (customWidth.m) {
        response = `
          ${response}

          ${mediaQueries.mobile} {
            width: ${typeof customWidth.m === 'number' ? `${customWidth.m}px` : customWidth.m} !important;
          }
        `;
      }

      if (customWidth.t) {
        response = `
          ${response}

          ${mediaQueries.tablet} {
            width: ${typeof customWidth.t === 'number' ? `${customWidth.t}px` : customWidth.t} !important;
          }
        `;
      }

      if (customWidth.d) {
        response = `
          ${response}

          ${mediaQueries.desktop} {
            width: ${typeof customWidth.d === 'number' ? `${customWidth.d}px` : customWidth.d} !important;
          }
        `;
      }

      return response;
    } else {
      return `
        width: ${typeof customWidth === 'number' ? `${customWidth}px` : customWidth} !important;
      `;
    }
  }};

  ${({ customHeight, theme: { mediaQueries } }) => {
    if (typeof customHeight === 'object') {
      let response = '';

      if (customHeight.m) {
        response = `
          ${response}

          ${mediaQueries.mobile} {
            height: ${typeof customHeight.m === 'number' ? `${customHeight.m}px` : customHeight.m} !important;
          }
        `;
      }

      if (customHeight.t) {
        response = `
          ${response}

          ${mediaQueries.tablet} {
            height: ${typeof customHeight.t === 'number' ? `${customHeight.t}px` : customHeight.t} !important;
          }
        `;
      }

      if (customHeight.d) {
        response = `
          ${response}

          ${mediaQueries.desktop} {
            height: ${typeof customHeight.d === 'number' ? `${customHeight.d}px` : customHeight.d} !important;
          }
        `;
      }

      return response;
    } else {
      return `
        height: ${typeof customHeight === 'number' ? `${customHeight}px` : customHeight} !important;
      `;
    }
  }};

  ${({ customMaxWidth, theme: { mediaQueries } }) => {
    if (typeof customMaxWidth === 'object') {
      let response = '';

      if (customMaxWidth.m) {
        response = `
          ${response}

          ${mediaQueries.mobile} {
            max-width: ${typeof customMaxWidth.m === 'number' ? `${customMaxWidth.m}px` : customMaxWidth.m} !important;
          }
        `;
      }

      if (customMaxWidth.t) {
        response = `
          ${response}

          ${mediaQueries.tablet} {
            max-width: ${typeof customMaxWidth.t === 'number' ? `${customMaxWidth.t}px` : customMaxWidth.t} !important;
          }
        `;
      }

      if (customMaxWidth.d) {
        response = `
          ${response}

          ${mediaQueries.desktop} {
            max-width: ${typeof customMaxWidth.d === 'number' ? `${customMaxWidth.d}px` : customMaxWidth.d} !important;
          }
        `;
      }

      return response;
    } else {
      return `
        max-width: ${typeof customMaxWidth === 'number' ? `${customMaxWidth}px` : customMaxWidth} !important;
      `;
    }
  }};

  ${({ customMaxHeight, theme: { mediaQueries } }) => {
    if (typeof customMaxHeight === 'object') {
      let response = '';

      if (customMaxHeight.m) {
        response = `
          ${response}

          ${mediaQueries.mobile} {
            max-height: ${typeof customMaxHeight.m === 'number' ? `${customMaxHeight.m}px` : customMaxHeight.m} !important;
          }
        `;
      }

      if (customMaxHeight.t) {
        response = `
          ${response}

          ${mediaQueries.tablet} {
            max-height: ${typeof customMaxHeight.t === 'number' ? `${customMaxHeight.t}px` : customMaxHeight.t} !important;
          }
        `;
      }

      if (customMaxHeight.d) {
        response = `
          ${response}

          ${mediaQueries.desktop} {
            max-height: ${typeof customMaxHeight.d === 'number' ? `${customMaxHeight.d}px` : customMaxHeight.d} !important;
          }
        `;
      }

      return response;
    } else {
      return `
        max-height: ${typeof customMaxHeight === 'number' ? `${customMaxHeight}px` : customMaxHeight} !important;
      `;
    }
  }};

  > iframe {
    width: 100%;
    height: 100%;
  }
`;

interface OnProgressState {
  playedSeconds: number;
  played: number;
  loadedSeconds: number;
  loaded: number;
}

const YoutubePlayer = ({
  externalVideoProviderIdOrUrl,
  onTimeUpdate,
  onEnd,
  duration,

  width = '100%',
  height = 'auto',
  maxWidth = 'inherit',
  maxHeight = 'inherit',
}: VideoPlayerProps): ReactElement => (
  <VideoPlayer
    url={`https://www.youtube.com/watch?v=${externalVideoProviderIdOrUrl}`}
    controls
    onProgress={(progress: OnProgressState) => {
      if (onTimeUpdate) onTimeUpdate(progress.playedSeconds);
    }}
    onEnded={() => {
      if (onEnd) onEnd(duration || 0);
    }}
    customWidth={width}
    customHeight={height}
    customMaxWidth={maxWidth}
    customMaxHeight={maxHeight}
  />
);

export default YoutubePlayer;
